import React, { useState } from "react";
import { ConfirmDialog, InputGroup } from "components";
import { useDeleteMutation } from "pages/Users/Users.query";
import { CButton, CLabel, CSelect } from "@coreui/react";
import CIcon from "@coreui/icons-react";

const DeleteUser = ({ title, url, identifier, isType, setApiType }) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const { mutateAsync: deleteUser, isLoading, } = useDeleteMutation(isType);
  const handleDeleteUser = async () => {
    try {
      const response = await deleteUser({ url, identifier })
      setIsDialogVisible(false)
    } catch (error) {
      console.log('error', error)
    }
  }

  return (
    <>
      <CButton
        onClick={() => setIsDialogVisible(true)}
        className={`buttons deleteButton bordered`}
      >
        <CIcon name="cil-Trash" />
        <span>DELETE</span>
      </CButton>
      <ConfirmDialog
        visible={isDialogVisible}
        handleClose={() => setIsDialogVisible(false)}
        handleAccept={() => {
          handleDeleteUser()
        }}
        loading={isLoading}
        message={
          <>
            {isType === "B2B" ?
              <div>
                <CLabel>
                  Delete Type
                  <InputGroup margin={false} prepend="Type">
                    <CSelect
                      required
                      name="Type"
                      onChange={(e) => { setApiType(e?.target?.value) }}
                    >
                      <option value="1">Delete User Only</option>
                      <option value="2">Delete Entire Care Home</option>
                    </CSelect>
                  </InputGroup>
                </CLabel>
              </div> : null}
            <span>
              Do you really want to delete <strong>{title}</strong>
            </span>
          </>
        }
      />
    </>
  );
};

export default DeleteUser;
